// extracted by mini-css-extract-plugin
export default {"ap-form-input":"Form_ap-form-input__TyGvE","ap-optional-label":"Form_ap-optional-label__nwA6x"};